import { Alert, Button, Text } from '@ui/themed';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useHandlers, useSite } from '../../../context/page-context';
import { track } from '../../../lib/mixpanel';
import { useInitiateDevelopmentPlanFlow } from '../hooks/use-initiate-development-plan-flow';

export function DevelopmentPlanBanner(): JSX.Element | null {
  const [isDismissed, setIsDismissed] = useState(false);
  const site = useSite();
  const { notificationHandler } = useHandlers();

  useEffect(() => {
    track(site, 'Development Plan Banner Viewed', {});
  }, [site]);
  const { mutate, isPending } = useInitiateDevelopmentPlanFlow({
    onError: () => {
      notificationHandler.error(
        t(
          'features:billing.components.development_plan_banner.errors.activation_failed_description',
        ),
      );
    },
  });

  if (isDismissed) {
    return null;
  }

  return (
    <Alert
      variant="info"
      headingLevel="h3"
      title={t('features:billing.components.development_plan_banner.title')}
      onDismiss={() => {
        track(site, 'Development Plan Banner Dismissed', {});
        setIsDismissed(true);
      }}
    >
      <div className="flex flex-col gap-2">
        <Text>{t('features:billing.components.development_plan_banner.description')}</Text>
        <Button type="button" variant="primary" loading={isPending} onClick={() => mutate()}>
          {t('features:billing.components.development_plan_banner.activate_button')}
        </Button>
      </div>
    </Alert>
  );
}
